/*
 * DISTRIBUTION STATEMENT C. Distribution authorized to U.S. Government Agencies and their contractors; Critical
 * Technology; 19 October 2017. Other requests for this document shall be referred to Chemical and Biological
 * Technologies, Defense Threat Reduction Agency, 8725 John J Kingman Road, Fort Belvoir, VA 22060-6201.
 *
 * WARNING: This document contains technical data whose export is restricted by the Arms Export Control Act (Sec 2751
 * of Title 22, United States Code) or the Export Control Reform Act of 2018 (Chapter 58 Sections 4801-4852 of Title
 * 50, United States Code). Violations of these export laws are subject to severe criminal penalties. Disseminate in
 * accordance with provisions of DoD Directive 5230.25 and DoD Instruction 2040.02. DESTRUCTION NOTICE: For
 * unclassified, limited distribution documents, destroy by any method that will prevent disclosure of the contents
 * or reconstruction of the document.
 *
 * This material is based upon work supported by the Under Secretary of War for Research and Engineering under Air
 * Force Contract No. FA8702-15-D-0001 or FA8702-25-D-B002. Any opinions, findings, conclusions or recommendations
 * expressed in this material are those of the author(s) and do not necessarily reflect the views of the Under
 * Secretary of War for Research and Engineering.
 *
 * © 2026 Massachusetts Institute of Technology.
 *
 * The software/firmware is provided to you on an As-Is basis
 *
 * Delivered to the U.S. Government with Unlimited Rights, as defined in DFARS Part 252.227-7013 or 7014 (Feb 2014).
 * Notwithstanding any copyright notice, U.S. Government rights in this work are defined by DFARS 252.227-7013 or
 * DFARS 252.227-7014 as detailed above. Use of this work other than as specifically authorized by the U.S.
 * Government may violate any copyrights that exist in this work.
 *
 * This document contains Controlled Unclassified Information (CUI). Handling of this information is subject to the
 * controls identified in DFARS 252.204-7012 - SAFEGUARDING COVERED DEFENSE INFORMATION AND CYBER INCIDENT REPORTING.
 */

import { connect } from 'react-redux'

// React Router
import {
  useLocation,
  useNavigate,
  Link as LinkRouter
} from 'react-router-dom';

// Material-UI
import { makeStyles } from 'tss-react/mui';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Link from '@mui/material/Link';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

// Rapids GUI Library
import { 
  Button, 
  Dropdown,
  NavigationBar
} from 'rapids-gui-library';

// App imports
import { showUserGuide } from '../utils/APIUtils.js';
import Banner from '../components/Banner.js';
import { OpenDocumentsPage } from "../pages/DocumentsPage";
import CuiBanner from "../components/CuiBanner";
import { classificationStyles } from "../styles/common";

// App images
import appLogo from '../assets/images/app_logo_wide_dark.svg'; // RAPIDS
import agentLogo from '../assets/images/app_logo_agent.svg';   // AGENT
import challengeLogo from '../assets/images/app_logo_adme.svg';  //CHALLENGE
import { ReactComponent as ChallengeLogo } from '../assets/images/app_logo_adme.svg';
// import challengeLogo from '../assets/images/ADME-Tox logo.svg';
import keyImg from '../assets/images/Key-2x.png';

// Icon imports
import { IconContext } from 'react-icons';
import { AiOutlinePlus, AiOutlineUser } from 'react-icons/ai';
import { BiHelpCircle } from 'react-icons/bi';
import { RxDropdownMenu } from 'react-icons/rx';
import { MdWorkspacesOutline } from "react-icons/md";

const useStyles = makeStyles()({
  navRight: {
    display: 'flex',
    justifyContent: 'right',
    width: '100%',
  },
  logo: {
    height: '45px',
    marginRight: '1%',
  },
  buttonBG: {
    margin: '5px 4px 0 0',
    minWidth: '160px',
    fontWeight: 'bold',
    fontSize: '16px',
  },
  buttonNoBG: {
    display: 'inline-flex',
    margin: '5px 0 0 0',
    padding: 0,
    minWidth: '30px'
  },
  buttonUser: {
    minWidth: '130px !important'
  },
  disclaimer: {
    margin: 0,
    padding: '12px 16px 0 16px !important',
    borderRadius: 0,
    backgroundColor: 'rgb(248, 215, 218) !important',
  },
  emailLink: {
    textDecoration:'underline',
    marginLeft:'0.3em'
  },
  quasiTabWrapper: {
    marginLeft: '4% !important',
    width: '100%',
    maxWidth: '800px',
  },
  quasiTab: {
    display: 'inline-flex',
    height: '100%',
    margin: '6px 0 0 0',
    padding: '15px calc(2px + 5%)',
    color: '#9FAAC5',
    minWidth: '40px',
    '&:hover': {
      color: 'white',
    },
    '&:active': {
      color: 'white',
    },
  },
  quasiTabActive: {
    color: 'white',
    borderBottom: 'solid 4px #9FAAC5',
  },
  dropdownButton: {
    height: '46px',
    backgroundColor: '#9FAAC5',
    '& a': {
      color: 'black',
    },
  },
  ...classificationStyles()
});

function ChallengeHeader({ dispatch, first_name, last_name, logged_in, email_verified, ethics_pledge, buildInfo,
                           userLoading, pageInfo, can_create_study, can_create_model, can_create_tool, my_team,
                           resources, kubeflowProvisioning, ...props }) {
  const { classes } = useStyles();
  const checkWidth = useMediaQuery('(min-width:992px)');
  const theme = useTheme();
  let navigate = useNavigate();

  let userName = last_name || '';
  userName += last_name && first_name ? ', ' : '';
  userName += first_name || '';

  let navWorkspaceDropdownTitle = (<div className={classes.buttonNoBG}>
    <MdWorkspacesOutline /> My Workspace
  </div>);

  let navUserDropdownTitle = (<div className={classes.buttonNoBG + ' ' + classes.buttonUser}>
    <AiOutlineUser /> {userName}
  </div>);

  let navHelpDropdownTitle = (<div className={classes.buttonNoBG}>
    <BiHelpCircle /> Help
  </div>);

  let navAboutTitle = (<div className={classes.buttonNoBG}>
    <BiHelpCircle /> About
  </div>);

  let navRegisterTitle = (<div className={classes.buttonNoBG}>
    <AiOutlineUser /> Register / Login
  </div>);

  let navMobileDropdownTitle = (<div className={classes.buttonNoBG}>
    <IconContext.Provider value={{ size: '3em' }}>
      <RxDropdownMenu />
    </IconContext.Provider>
  </div>);

  let navAddTitle = (<div className={classes.buttonBG}>
    <AiOutlinePlus style={{ marginTop: '-8px', fontSize: '1.2rem'}} /> Add to {window._env_.APP_NAME}
  </div>);


  function Header() {
    let location = useLocation();
    let header = (<></>);

    // console.log('Header info', window._env_);
    if (userName && logged_in && email_verified && ethics_pledge) { // Logged-in, full account access
      header = (<>
        <NavigationBar collapseOnSelect bg='dark' backgroundColor='black'
                       style={{ fontSize: '14px'}}>
          <div className={classes.navRight}>
            <Button variant='text' onClick={() => navigate('/userprofile')} style={{color: '#9FAAC5'}}>
              {navWorkspaceDropdownTitle}
            </Button>

            <Dropdown title={navHelpDropdownTitle} variant='text' style={{color: '#9FAAC5'}}>
              <MenuItem onClick={() => navigate('/guide')}>About</MenuItem>
              <MenuItem onClick={() => navigate('/guide?page=DataPolicies')}>Data Policies</MenuItem>
              <MenuItem onClick={(e) => showUserGuide()}>{window._env_.APP_NAME} User Guide (PDF)</MenuItem>
            </Dropdown>

            <Dropdown title={navUserDropdownTitle} variant='text' style={{color: '#9FAAC5'}}>
              <MenuItem onClick={() => navigate('/userprofile')}>User Profile and Studies</MenuItem>
              <MenuItem onClick={() => navigate('/ethicspledge')}>Ethics Pledge</MenuItem>
              <Divider />
              <Link href={window._env_.APP_LOGOUT} underline='none'>
                <MenuItem>Log out</MenuItem>
              </Link>
            </Dropdown>
          </div>
        </NavigationBar>

        <NavigationBar collapseOnSelect bg='dark' variant='dark'
                       style={{ borderBottom: 'solid 5px #003E65', fontSize: '16px'}}>
          <LinkRouter to='/'>
            {(window._env_?.CUI_APP) &&
                <img src={agentLogo} alt={window._env_.APP_NAME} className={'d-inline-block align-top ' + classes.logo} />
            }
            {(!window._env_?.CUI_APP && window._env_.APP_SITE !== 'challenge') &&
                <img src={appLogo} alt={window._env_.APP_NAME} className={'d-inline-block align-top ' + classes.logo} />
            }
            {(!window._env_?.CUI_APP && window._env_.APP_SITE === 'challenge') &&
                <ChallengeLogo alt={window._env_.APP_CHALLENGE_NAME} className={'d-inline-block align-top ' + classes.logo} />
            }
          </LinkRouter>

          <div className={classes.quasiTabWrapper}>
            {(my_team) &&
                <LinkRouter
                    className={classes.quasiTab + ' ' + (location?.pathname === '/my_team' && classes.quasiTabActive)}
                    to='/my_team'>My Team</LinkRouter>
            }
            {(resources?.includes('studies')) &&
                <LinkRouter
                    className={classes.quasiTab + ' ' + (location?.pathname === '/studies' && classes.quasiTabActive)}
                    to='/studies'>Studies</LinkRouter>
            }
            {(pageInfo?.feature_analyst_workbench && resources?.includes('models')) &&
              <LinkRouter className={classes.quasiTab + ' ' + (location?.pathname === '/algorithms' && classes.quasiTabActive)} to='/algorithms'>Models</LinkRouter>
            }
            {(pageInfo?.tools_page && resources?.includes('tools')) &&
              <LinkRouter className={classes.quasiTab + ' ' + (location?.pathname === '/tools' && classes.quasiTabActive)} to='/tools'>Tools</LinkRouter>
            }
            {(pageInfo?.feature_pipeline && kubeflowProvisioning) &&
              <LinkRouter className={classes.quasiTab + ' ' + (location?.pathname === '/pipelinestudio' && classes.quasiTabActive)} to='/pipelinestudio'>Pipeline Studio</LinkRouter>
            }
          </div>

          <div className={classes.navRight}>
            {!checkWidth &&
              <Dropdown align='end' title={navMobileDropdownTitle} noArrow id='mobile-nav-dropdown'>
                {can_create_study &&
                  <MenuItem onClick={() => navigate('/registerstudy', { state: { previousPage: location?.pathname } })}>New Study</MenuItem>
                }
                {(pageInfo?.feature_analyst_workbench && can_create_model) &&
                  <MenuItem onClick={() => navigate('/registeralgorithm', { state: { previousPage: location?.pathname } })}>New Model</MenuItem>
                }
                {(pageInfo?.feature_cohort) &&
                  <MenuItem onClick={() => navigate('/cohort', { state: { previousPage: location?.pathname } })}>New Cohort</MenuItem>
                }
                {(pageInfo?.tools_page && can_create_tool) &&
                  <MenuItem onClick={() => navigate('/registertool', { state: { previousPage: location?.pathname } })}> New Tool</MenuItem>
                }
                {/*{(pageInfo?.tools_page) &&*/}
                {/*  <MenuItem onClick={() => navigate('/tools', { state: { previousPage: location?.pathname } })}>Tools</MenuItem>*/}
                {/*}*/}
              </Dropdown>
            }
            {checkWidth && <>
              {(can_create_study || (pageInfo?.feature_analyst_workbench && can_create_model) ||
                      (pageInfo?.tools_page && can_create_tool) ||pageInfo?.feature_cohort) &&
                <Dropdown
                    className={classes.dropdownButton}
                    align='end'
                    id='mobile-nav-dropdown'
                    // as={Button}
                    title={navAddTitle}
                    overrides={{
                      menu: {
                        styles: {
                          minWidth: '212px',
                          backgroundColor: '#9FAAC5'
                        }
                      },
                      button: {
                        styles: {
                          backgroundColor: '#9FAAC5',
                          '&:hover': {
                            backgroundColor: '#382962',
                          }
                        }
                      }
                    }} >
                  {can_create_study &&
                    <MenuItem onClick={() => navigate('/registerstudy', { state: { previousPage: location?.pathname } })}> New Study</MenuItem>
                  }
                  {(pageInfo?.feature_analyst_workbench && can_create_model) &&
                    <MenuItem onClick={() => navigate('/registeralgorithm', { state: { previousPage: location?.pathname } })}> New Model</MenuItem>
                  }
                  {pageInfo?.feature_cohort &&
                    <MenuItem onClick={() => navigate('/cohort', { state: { previousPage: location?.pathname } })}> New Cohort</MenuItem>
                  }
                  {(pageInfo?.tools_page && can_create_tool) &&
                    <MenuItem onClick={() => navigate('/registertool', { state: { previousPage: location?.pathname } })}> New Tool</MenuItem>
                  }
                </Dropdown>
              }
            </>}
          </div>
        </NavigationBar>
      </>);
    } else if (userName) { // Logged-in, incomplete account access
      header = (<>
        <NavigationBar collapseOnSelect bg='dark' backgroundColor='black' style={{ fontSize: '14px', }}>
          <div className={classes.navRight}>
            <Button variant='text' onClick={() => navigate('/userprofile')}>{navWorkspaceDropdownTitle}</Button>

            <Dropdown title={navHelpDropdownTitle} variant='text'>
              <MenuItem onClick={() => navigate('/guide')}>About</MenuItem>
              <MenuItem onClick={() => navigate('/guide?page=DataPolicies')}>Data Policies</MenuItem>
              <MenuItem onClick={(e) => showUserGuide()}>{window._env_.APP_NAME} User Guide (PDF)</MenuItem>
            </Dropdown>

            <Dropdown title={navUserDropdownTitle} variant='text'>
              <MenuItem onClick={() => navigate('/userprofile')}>User Profile and Studies</MenuItem>
              <MenuItem onClick={() => navigate('/ethicspledge')}>Ethics Pledge</MenuItem>
              <Divider />
              <Link href={window._env_.APP_LOGOUT} underline='none'>
                <MenuItem>Log out</MenuItem>
              </Link>
            </Dropdown>
          </div>
        </NavigationBar>

        <NavigationBar collapseOnSelect bg='dark' variant='dark' style={{ borderBottom: 'solid 5px #003E65', fontSize: '16px', }}>
          <LinkRouter to='/'>
            {(window._env_?.CUI_APP) &&
                <img src={agentLogo} alt={window._env_.APP_NAME} className={'d-inline-block align-top ' + classes.logo} />
            }
            {(!window._env_?.CUI_APP && window._env_.APP_SITE !== 'challenge') &&
                <img src={appLogo} alt={window._env_.APP_NAME} className={'d-inline-block align-top ' + classes.logo} />
            }
            {(!window._env_?.CUI_APP && window._env_.APP_SITE === 'challenge') &&
                <ChallengeLogo alt={window._env_.APP_CHALLENGE_NAME} className={'d-inline-block align-top ' + classes.logo} />
            }
          </LinkRouter>

          <div className={classes.quasiTabWrapper}>
          {/*  <LinkRouter className={classes.quasiTab + ' ' + (location?.pathname === '/studies' && classes.quasiTabActive)} to='/studies'>Studies</LinkRouter>*/}
          {/*  {(pageInfo?.feature_analyst_workbench) &&*/}
          {/*    <LinkRouter className={classes.quasiTab + ' ' + (location?.pathname === '/algorithms' && classes.quasiTabActive)} to='/algorithms'>Models</LinkRouter>*/}
          {/*  }*/}
          {/*  {(pageInfo?.tools_page) &&*/}
          {/*    <LinkRouter className={classes.quasiTab + ' ' + (location?.pathname === '/tools' && classes.quasiTabActive)} to='/tools'>Tools</LinkRouter>*/}
          {/*  }*/}
          </div>
        </NavigationBar>
      </>);
    } else { // Not logged-in, public view
      // console.log('anonymous', pageInfo);
      header = (<>
        <NavigationBar collapseOnSelect bg='dark' backgroundColor='black' style={{ fontSize: '14px', }}>
          <div className={classes.navRight}>
            <Button variant='text' onClick={() => navigate('/guide')} style={{color: '#9FAAC5'}}>
              <BiHelpCircle /> About
            </Button>
            <Button variant='text' style={{color: '#9FAAC5'}} href={'/secure?cp=' + location.pathname + '&t=' + Date.now().toString()}>
              <AiOutlineUser /> Register / Login
            </Button>
          </div>
        </NavigationBar>

        <NavigationBar collapseOnSelect bg='dark' variant='dark' style={{ borderBottom: 'solid 5px #003E65', fontSize: '16px', }}>
          <LinkRouter to='/'>
            {(window._env_?.CUI_APP) &&
                <img src={agentLogo} alt={window._env_.APP_NAME} className={'d-inline-block align-top ' + classes.logo} />
            }
            {(!window._env_?.CUI_APP && window._env_.APP_SITE !== 'challenge') &&
                <img src={appLogo} alt={window._env_.APP_NAME} className={'d-inline-block align-top ' + classes.logo} />
            }
            {(!window._env_?.CUI_APP && window._env_.APP_SITE === 'challenge') &&
                <ChallengeLogo alt={window._env_.APP_CHALLENGE_NAME} className={'d-inline-block align-top ' + classes.logo} />
            }
          </LinkRouter>

          <div className={classes.quasiTabWrapper}>
            {/*<LinkRouter className={classes.quasiTab + ' ' + (location?.pathname === '/studies' && classes.quasiTabActive)} to='/studies'>Studies</LinkRouter>*/}
            {/*{(pageInfo?.feature_analyst_workbench) &&*/}
            {/*  <LinkRouter className={classes.quasiTab + ' ' + (location?.pathname === '/algorithms' && classes.quasiTabActive)} to='/algorithms'>Models</LinkRouter>*/}
            {/*}*/}
            {/*{(pageInfo?.tools_page) &&*/}
            {/*  <LinkRouter className={classes.quasiTab + ' ' + (location?.pathname === '/tools' && classes.quasiTabActive)} to='/tools'>Tools</LinkRouter>*/}
            {/*}*/}
          </div>
        </NavigationBar>
      </>);
    }

    return header;
  }

  function PrettyBanner() {
    let prettyBanner = (<></>);
    let message;
    let actionButton;

    if (userLoading) {
      message = 'Please wait while app and user information is being retrieved.';

      prettyBanner = (
        <Banner
          type='info'
          title='Loading...'
          message = {message}
          />
      );
    } else if (userName && !email_verified) { // User needs to verify account via email
      message = 'Please check your email to confirm your account.';

      prettyBanner = (
        <Banner
          type='warning'
          title={'Thank you for your interest in ' + window._env_.APP_NAME + '!'}
          message = {message}
          image={keyImg}
          />
      );
    }

    return prettyBanner;
  }

  return (
    <IconContext.Provider value={{ size: '1.4em', style: {marginTop: '-1px', marginRight: '8px'} }}>
      <CuiBanner />
      <Disclaimer />
      <Header />
      <PrettyBanner />
      <CuiBanner stickyTop={true} />
    </IconContext.Provider>
  );
}

function Disclaimer() {
  const { classes } = useStyles();
  if (window._env_?.SHOW_DISCLAIMER) {
    return (
        <Alert severity='error' className={classes.disclaimer}>
          <AlertTitle>Important Disclaimer</AlertTitle>
          <p>
            The {window._env_.APP_NAME} system is currently under development.
            Future releases of {window._env_.APP_NAME} will implement additional capabilities.
            Questions? Contact:
            <a href={'mailto:' + window._env_.APP_SUPPORT_EMAIL + '?subject=' + window._env_.APP_NAME + ' Question'}
               className={classes.emailLink}>
              {window._env_.APP_SUPPORT_EMAIL}
            </a>
          </p>
        </Alert>
    );
  }
  return (<></>);
}

const mapStateToProps = (state) => {
  return {
    first_name: state.userInfo.first_name,
    last_name: state.userInfo.last_name,
    email: state.userInfo.email,
    logged_in: state.userInfo.logged_in,
    email_verified: state.userInfo.email_verified,
    ethics_pledge: state.userInfo.ethics_pledge,
    userLoading: state.userLoading,
    buildInfo: state.buildInfo,
    pageInfo: state.pageInfo,
    can_create_study: state.userInfo.can_create_study,
    can_create_model: state.userInfo.can_create_model,
    can_create_tool: state.userInfo.can_create_tool,
    my_team: state.userInfo.my_team,
    resources: state.userInfo.available_resources,
    kubeflowProvisioning: state.kubeflowProvisioning,
  }
}

export default connect(mapStateToProps)(ChallengeHeader);